import enviro from 'enviro';
import { parse } from './Params';
import type { GetPayload, SyncMessage } from '../types';

export interface EmbedOptions {
  enableTopLevelEmbed?: boolean;
  enableTopLevelEmbedForTestOnly?: boolean;
  allowedOrigins?: readonly string[];
}

export const isTopLevelWindowSupported = (
  { enableTopLevelEmbed, enableTopLevelEmbedForTestOnly }: EmbedOptions = {},
  top = window.top
): boolean =>
  window === top &&
  !!(enableTopLevelEmbed || (enviro.isQa() && enableTopLevelEmbedForTestOnly));

export const getEmbeddedPropsFromQueryParams = (
  search = window.location.search
) => parse(search);

export const getTopLevelEmbeddedContextDefaults =
  (): GetPayload<SyncMessage> => ({
    embedId: 'top',
    group: 'iframeable',
    name: 'embed-top',
    appData: { info: {}, name: 'unknown', url: '' },
  });
